import React, { useState } from "react";
import ErrorIcon from "@atlaskit/icon/glyph/error";
import InfoIcon from "@atlaskit/icon/glyph/info";
import WarningIcon from "@atlaskit/icon/glyph/warning";
import SuccessIcon from "@atlaskit/icon/glyph/check-circle";
import { R400, Y200, N500, G400 } from "@atlaskit/theme/colors";
import { token } from "@atlaskit/tokens";
import { AutoDismissFlag, FlagGroup } from "@atlaskit/flag";

const FlagError = ({ setFlag, message }) => {
  const [flags, setFlags] = useState(setFlag);
  const handleDismiss = () => {
    setFlags(flags.slice(1));
  };
  const handleSetIcon = (type) => {
    if (type === "error") {
      return (
        <ErrorIcon
          label="Error"
          secondaryColor={token("color.iconBorder.danger", R400)}
        />
      );
    } else if (type === "info") {
      return (
        <InfoIcon
          label="Info"
          secondaryColor={token("color.iconBorder.discovery", N500)}
        />
      );
    } else if (type === "success") {
      return (
        <SuccessIcon
          label="Success"
          secondaryColor={token("color.iconBorder.success", G400)}
        />
      );
    } else if (type === "warning") {
      return (
        <WarningIcon
          label="Warning"
          secondaryColor={token("color.iconBorder.warning", Y200)}
        />
      );
    } else {
      return (
        <ErrorIcon
          label="Error"
          secondaryColor={token("color.iconBorder.danger", R400)}
        />
      );
    }
  };
  return (
    <div>
      <FlagGroup onDismissed={handleDismiss}>
        {flags.map((flagId) => {
          return (
            <AutoDismissFlag
              appearance={message.appearance || "error"}
              id={flagId}
              icon={handleSetIcon(message.appearance || "")}
              key={flagId}
              title={message.text || message}
            />
          );
        })}
      </FlagGroup>
    </div>
  );
};

export default FlagError;
